module.exports = __webpack_public_path__ + "img/92.be618b16.jpg";